import { CircularProgress, makeStyles } from '@material-ui/core';
import { ReactElement, useRef } from 'react';

interface IProps {
  children: ReactElement[];
  fetchMore: () => void;
  hasMoreToFetch: boolean;
  fetching: boolean;
}

const useStyles = makeStyles((theme) => ({
  carouselWrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    maxWidth: '100%',
    overflowX: 'scroll',
    overflowY: 'hidden',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    padding: theme.spacing(0, 6),
    paddingBottom: theme.spacing(6),
    '& > div': {
      marginRight: theme.spacing(4),
    },
    '& > div:last-child': {
      marginRight: 0,
    },
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 169,
    marginLeft: theme.spacing(6),
    minWidth: 120,
  },
}));

const CarouselMobile = (props: IProps) => {
  const classes = useStyles();
  const containerRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    if (!containerRef.current || props?.fetching) return;
    const { offsetWidth, scrollLeft, scrollWidth } = containerRef.current;
    const scrollCurrentIndex = Math.round(offsetWidth + scrollLeft);
    const thresholdIndex = scrollWidth - 10;
    if (scrollCurrentIndex >= thresholdIndex && props.hasMoreToFetch && props.fetchMore) {
      props?.fetchMore();
    }
  };

  return (
    <div id='showcase-list' ref={containerRef} onScroll={handleScroll} className={classes.carouselWrapper}>
      {props.children}
      {props?.fetching && props.hasMoreToFetch && (
        <div className={classes.loading}>
          <CircularProgress size={50} />
        </div>
      )}
    </div>
  );
};

export default CarouselMobile;
